export default {
    state: {
        siteId: null,
        tree: null,
    },
    mutations: {
        setSelectedSite(state, siteId) {
            state.siteId = siteId;
        },
        setSelectedTree(state, tree) {
            state.tree = tree;
        },
    },
    actions: {
        changeSelectedSite({ commit }, siteId) {
            commit('setSelectedSite', siteId);
        },
        changeSelectedTree({ commit }, tree) {
            commit('setSelectedTree', tree);
        },
    },
    getters: {
        selectedSite: state => state.siteId,
        selectedTree: state => state.tree,
    },
};
